
import React from 'react';
import { Mail, Calendar, ExternalLink } from 'lucide-react';
import SocialLinks from './SocialLinks';

interface ContactInfoProps {
  isVisible: boolean;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ isVisible }) => {
  return (
    <div className={`transition-all duration-700 delay-300 ${isVisible ? 'opacity-100' : 'opacity-0 translate-x-8'}`}>
      <div className="bg-presintention-light rounded-xl p-8 h-full">
        <h3 className="text-xl font-bold mb-6">Get in Touch</h3>
        
        <div className="space-y-6">
          <div className="flex items-start">
            <Mail className="h-5 w-5 text-presintention-accent mt-1 mr-4" />
            <div>
              <h4 className="font-medium">Contact Us</h4>
              <p className="text-presintention-muted">
                Fill out the form or email us directly at{" "}
                <a 
                  href="mailto:Alex@presintention.com" 
                  className="text-presintention-accent hover:underline flex items-center inline-flex"
                >
                  Alex@presintention.com
                  <ExternalLink className="h-3.5 w-3.5 ml-1 inline" />
                </a>
              </p>
            </div>
          </div>
          
          <div className="flex items-start">
            <Calendar className="h-5 w-5 text-presintention-accent mt-1 mr-4" />
            <div>
              <h4 className="font-medium">Schedule a Call</h4>
              <a 
                href="https://calendly.com/alex-fairlie" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-presintention-accent hover:underline flex items-center"
              >
                Book a 30-minute consultation
                <ExternalLink className="h-3.5 w-3.5 ml-1 inline" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-12">
          <h4 className="font-medium mb-3">Follow Us</h4>
          <SocialLinks />
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
